import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type TInitialState = {
  currentSectionIndex: number;
  questionAnswerMap: {
    [questionId: string]: string;
  };
  updateReviews?: boolean;
  allQuestionsSubmitted?: boolean;
};

const companyReviewsInitialState: TInitialState = {
  currentSectionIndex: 0,
  questionAnswerMap: {},
  updateReviews: false,
  // null => when the responses were not fetched after the company review component mount
  // true => when the responses for all the questions have already been submitted by the user,
  // otherwise => false
  allQuestionsSubmitted: null,
};

const companyReviewsSlice = createSlice({
  name: 'companyReviews',
  initialState: companyReviewsInitialState,
  reducers: {
    goToNextSection(state) {
      state.currentSectionIndex += 1;
    },
    submitQuestionAnswer(state, action: PayloadAction<{ questionId: string; answer: string }>) {
      const { questionId, answer } = action.payload;
      state.questionAnswerMap = {
        ...state.questionAnswerMap,
        [questionId]: answer,
      };
    },
    setQuestionAnswerMap(
      state,
      action: PayloadAction<{
        [questionId: string]: string;
      }>
    ) {
      state.questionAnswerMap = {
        ...state.questionAnswerMap,
        ...action.payload,
      };
    },
    setUpdateReviews(state, action: PayloadAction<boolean>) {
      state.updateReviews = action.payload;
    },
    setAllQuestionsSubmitted(state, action: PayloadAction<boolean>) {
      state.allQuestionsSubmitted = action.payload;
    },
  },
});

export const {
  goToNextSection,
  setUpdateReviews,
  setQuestionAnswerMap,
  submitQuestionAnswer,
  setAllQuestionsSubmitted,
} = companyReviewsSlice.actions;

export default companyReviewsSlice.reducer;
